import React from "react";
import img1 from "../../../images/about.jpg";

export default function AboutNII() {
  return (
    <section className="about-nii">
      <div className="about-nii__first">
        <div className="about-nii__description">
          <h2 className="about-nii__title">О нас</h2>
          <p className="about-nii__text">
            ГБУ СО «УрНИИДВиИ» - оказывает специализированную медико-санитарную
            помощь в амбулаторных условиях, специализированную в том числе
            высокотехнологичную медицинскую помощь в условиях круглосуточного и
            дневного стационаров по профилю "дерматовенерология".
          </p>
        </div>
        <img src={img1} alt="Доктор" className="about-nii__image"></img>
      </div>
      <div className="about-nii__blocks">
        <div className="about-nii__block">
          <div className="about-nii__block_image about-nii__block_image-time"></div>
          <h4 className="about-nii__block-title">94 года работы</h4>
          <p className="about-nii__block-text">
            Собственная лабораторная и клиническая база в 200 коек
          </p>
        </div>
        <div className="about-nii__block">
          <div className="about-nii__block_image about-nii__block_image-doctors"></div>
          <h4 className="about-nii__block-title">
            12 Докторов медицинских наук 15 Кандидов медицинских наук 7
            Профессоров
          </h4>
          <p className="about-nii__block-text">
            Высококвалифицированный профессорский состав
          </p>
        </div>
        <div className="about-nii__block">
          <div className="about-nii__block_image about-nii__block_image-build"></div>
          <h4 className="about-nii__block-title">
            Круглосуточный и дневной стационары, консультативно- диагностическое
            отделение
          </h4>
          <p className="about-nii__block-text">
            Вы можете получить непрерывное наблюдение и лечение, не прерывая
            привычный образ жизни
          </p>
        </div>
        <div className="about-nii__block">
          <div className="about-nii__block_image about-nii__block_image-medic"></div>
          <h4 className="about-nii__block-title">34 врача</h4>
          <p className="about-nii__block-text">
            Наш главный приоритет — здоровье и комфорт наших пациентов
          </p>
        </div>
      </div>
    </section>
  );
}
